window.selectedCustomizations = [];
window.availableOptions = [];
window.customisable = false;

// Helper function to get localized title
window.getLocalizedTitle = function(item, fallbackTitle) {
  if (!item) return fallbackTitle || '';
  const isGerman = window.shopLocale && (window.shopLocale === 'de' || window.shopLocale.startsWith('de-'));
  return (isGerman && item.title_de) ? item.title_de : (item.title || fallbackTitle || '');
};

window.cartButtonState = $(".product-form__submit").prop("disabled");
window.cartButtonText = $(".product-form__submit span").text();

let optimizing_style = $(".product").attr("product-style");
if (optimizing_style.length > 0) {
  $(".product-form__submit").prop("disabled", true);
  $(".product-form__submit span").text("Loading customisations");
  window.customisable = true;
} else {
  $(".product_customization").hide();
}
/* hide save changes button by default and only show for editing customizations */

$(".save_changes_button").hide();

/* check dependable options and show and hide options accordingly */

function check_depends() {
  removeDependent();

  $(".product-info--selected-options").slick("slickUnfilter");

  let allDependant = document.querySelectorAll("[depends-on-option-value]");

  $(allDependant).each(function (index, element) {
    var parent_ids_array = $(element)
      .attr("depends-on-option-value")
      .split(",")
      .map(Number);

    let state = "hide";

    for (let dpd of parent_ids_array) {
      if (
        window.selectedCustomizations.find((item) => item.value_id === +dpd) !==
        undefined
      )
        state = "show";
    }

    let exists = parent_ids_array.some((ai) =>
      window.availableOptions.includes(ai)
    );

    if ($(element).is("li")) {
      /* preselect dependent option value */
      //if (window.selectedCustomizations.find(item => item.value_id === +$(element).attr('depends-on-option-value')) !== undefined) $(element).click();
    }
    if ($(element).hasClass("slick-slide")) {
      // do not hide slick slides since it breaks the slider -> use slickFilter instead
      state === "hide" && exists
        ? $(element).removeClass("show")
        : $(element).addClass("show");
    } else {
      if (state === "hide" && exists) {
        $(element).addClass("hide").hide();
      } else {
        if ($(element).hasClass("hide")) {
          // add the default selected option for the newly shown element to trigger check dependables for this new option
          updateSelectedOptions({
            option_id: +$(element).attr("option-id"),
            option_name: $(element).find("li.active").attr("data-item"),
            value_name: $(element).find("li.active").attr("data-value"),
            value_id: +$(element).find("li.active").attr("item-id"),
            option_depends_on:
              $(element).attr("depends-on-option-value") === undefined
                ? []
                : $(element)
                  .attr("depends-on-option-value")
                  .split(",")
                  .map(Number),
            value_depends_on:
              $(element).find("li.active").attr("depends-on-option-value") ===
                undefined
                ? []
                : $(element)
                  .find("li.active")
                  .attr("depends-on-option-value")
                  .split(",")
                  .map(Number),
          });
          $(element).removeClass("hide").fadeIn();
        }
      }
    }
  });

  $(".product-info--selected-options").slick("slickFilter", ".show");
}

/* check and remove dependent options */

function removeDependent() {
  let i = window.selectedCustomizations.length;

  for (i = 0, len = window.selectedCustomizations.length; i < len; i++) {
    if (window.selectedCustomizations[i] === undefined) break;

    let exists = window.selectedCustomizations[i].option_depends_on.some((ai) =>
      window.availableOptions.includes(ai)
    );

    let optionDeleted = false;

    if (
      window.selectedCustomizations[i].option_depends_on.length > 0 &&
      exists
    ) {
      // removing dependent options
      if (
        window.selectedCustomizations.findIndex((item) =>
          window.selectedCustomizations[i].option_depends_on.includes(
            item.value_id
          )
        ) === -1
      ) {
        window.selectedCustomizations.splice(i, 1);
        optionDeleted = true;
        i--;
      }
    }
    if (
      window.selectedCustomizations[i].value_depends_on.length > 0 &&
      !optionDeleted
    ) {
      // removing dependent values
      if (
        window.selectedCustomizations.findIndex((item) =>
          window.selectedCustomizations[i].value_depends_on.includes(
            item.value_id
          )
        ) === -1
      ) {
        window.selectedCustomizations.splice(i, 1);
        i--;
      }
    }
  }
}

$(document).ready(function () {
  /* fetch customisations for the product */

  if ($(".product").length) {
    getCustomisations();
  }

  if (window.customisable) {
    if ($('input[name="properties[_editCustomizations]"]').length > 0) {
      let random_id =
        Math.floor(Math.random() * (99999999 - 10000001)) + 10000001;
      $('input[name="properties[_editCustomizations]"]')
        .val(random_id)
        .change();
    }
  }
});

/* Get customisations */

async function getCustomisations() {
  let optimizing_style = $(".product").attr("product-style");
  if (optimizing_style.length === 0) return;

  let p_type =
    $(".product").attr("product-type")[0].toUpperCase() +
    $(".product").attr("product-type").substring(1);

  let tuxedo = $(".product").attr("tuxedo");

  if (tuxedo !== "true" && tuxedo !== true) {
    tuxedo = false;
  }

  // if (customisations.length === 0) {

  let customisations = await $.get(
    "https://api.v3.editsuits.com/customisations/" +
    optimizing_style +
    "/" +
    p_type +
    "/" +
    tuxedo
  );

  // }

  if (customisations.length > 0) {
    let popups = "";
    let html = "";

    for (var i = 0; i < customisations.length; i++) {

      if (!customisations[i]["tab"]["options"].length) continue;

      let iIcon =
        '<span><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" type="info" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg></span>';
      let iCon = '';

      /* setting default option on first load */

      let defaultOption = customisations[i]["tab"]["options"].find(
        (item) =>
          item.option_value_id === customisations[i]["tab"]["default_option"]
      );
      
      // Use original title for metafield names, localized title for display
      let tabPropertyName = customisations[i]["tab"]["title"];
      let tabTitle = getLocalizedTitle(customisations[i]["tab"]);
      let defaultOptionPropertyValue = defaultOption ? defaultOption.title : '';
      let defaultOptionTitle = defaultOption ? getLocalizedTitle(defaultOption) : ''; 
      let defaultOptionImage = defaultOption ? defaultOption.image : '';
      let defaultOptionDescription = defaultOption ? defaultOption.description : '';
      let option_depends_on = "";

      if (customisations[i]["tab"]["depends_on_option_value"].length > 0)
        option_depends_on =
          'depends-on-option-value="' +
          customisations[i]["tab"]["depends_on_option_value"] +
          '"';

      let image = "";
      if (customisations[i]["tab"]["options"] != "undefined") {
        if (
          customisations[i]["tab"]["options"][0]["image"] != "undefined" &&
          customisations[i]["tab"]["options"][0]["image"] != null
        ) {
          //   image = '<img  src="' + customisations[i]['tab']['options'][0]['image'] + '" alt="' + customisations[i]['tab']['options'][0]['title'] + '">';
          image =
            '<img  src="' +
            defaultOptionImage +
            '" alt="' +
            customisations[i]["tab"]["options"][0]["title"] +
            '">';
        }

        /* creating style details element */

        html +=
          "<div " +
          option_depends_on +
          '  class="show item item-mobile" data-option="' +
          tabPropertyName +
          '">' +
          iCon +
          image +
          '<div class="text_descr"><div><span class="option_title">' +
          tabTitle +
          "<small>" +
          defaultOptionTitle +
          "</small></span><p>" +
          defaultOptionDescription +
          '</p></div></div><div class="text_desc_mobile"><span>' +
          defaultOptionTitle +
          "</span><p>" +
          defaultOptionDescription +
          "</p></div></div>";

        /* setting up product properties in the add to cart form */

        $(".product-form-add").append(
          '<input type="hidden" name="properties[_' +
          tabPropertyName +
          ']" value="' +
          defaultOptionPropertyValue +
          '">'
        );

        updateSelectedOptions({
          option_id: +customisations[i]["tab"]["option_id"],
          option_name: tabPropertyName,
          value_name: defaultOptionPropertyValue,
          value_id: +customisations[i]["tab"]["default_option"],
          option_depends_on:
            customisations[i]["tab"]["depends_on_option_value"],
          value_depends_on: customisations[i]["tab"]["options"].find(
            (item) =>
              item.option_value_id ===
              customisations[i]["tab"]["default_option"]
          ).depends_on_option_value,
        });

        /* do not show single option tabs in customizer */

    //    if (customisations[i]["tab"]["options"].length < 2) continue;
        var option_item_head =
          '<div class="option_item_head">' +
          image +
          "<span class='option_title'>" +
          tabTitle +
          "<small>" +
          defaultOptionTitle +
          "</small></span></div>";
        var option_item_body_item = "";

        for (var j = 0; j < customisations[i]["tab"]["options"].length; j++) {
          window.availableOptions.push(
            customisations[i]["tab"]["options"][j]["option_value_id"]
          );

          let optionPropertyValue = customisations[i]["tab"]["options"][j]["title"];
          let optionTitle = getLocalizedTitle(customisations[i]["tab"]["options"][j]);

          let value_depends_on = "";
          if (
            customisations[i]["tab"]["options"][j]["depends_on_option_value"]
              .length > 0
          )
            value_depends_on =
              'depends-on-option-value="' +
              customisations[i]["tab"]["options"][j][
              "depends_on_option_value"
              ] +
              '"';
          let active = "";
          if (
            customisations[i]["tab"]["default_option"] ===
            customisations[i]["tab"]["options"][j]["option_value_id"]
          ) {
            active = "active";
          }
          let icon = "";
          if (
            customisations[i]["tab"]["options"][j]["image"] != null &&
            customisations[i]["tab"]["options"][j]["image"] != "undefined"
          ) {
            icon =
              '<img  src="' +
              customisations[i]["tab"]["options"][j]["image"] +
              '" alt="' +
              optionTitle +
              '">';
          }

          /* creating additional info popup */
          let info_slider_images = "";
          if (
            customisations[i]["tab"]["options"][j]["additional_images"]
              .length === 0
          ) {
            info_slider_images +=
              '<div class="item"><img  src="' +
              customisations[i]["tab"]["options"][j]["image"] +
              '" alt="' +
              optionTitle +
              '" /></div>';
          } else {
            for (
              var t = 0;
              t <
              customisations[i]["tab"]["options"][j]["additional_images"]
                .length;
              t++
            ) {
              info_slider_images +=
                '<div class="item"><img  src="' +
                customisations[i]["tab"]["options"][j]["additional_images"][t] +
                '" alt="' +
                optionTitle +
                '" /></div>';
            }
          }
          let info_slider =
            '<div class="info_slider">' + info_slider_images + "</div>";

          let oftenChosen = "";
          if (
            customisations[i]["tab"]["options"][j]["option_value_id"] ===
            customisations[i]["tab"]["default_option"]
          ) {
            oftenChosen = "<div class='often_chosen'>Often chosen</div>";
          }
          
          // Hide description for German locales
          const isGerman = window.shopLocale && (window.shopLocale === 'de' || window.shopLocale.startsWith('de-'));
          const descriptionHtml = isGerman ? '' : '<p>' + customisations[i]["tab"]["options"][j]["description"] + '</p>';
          
          let popup =
            '<div id="option_info_popup_' +
            customisations[i]["tab"]["options"][j]["option_value_id"] +
            '" class="option_info_popup"><a href="#" class="close_info"></a><div class="information"><span class="popupTitle caption-with-letter-spacing caption-with-letter-spacing--medium caption-with-letter-spacing">' +
            tabTitle +
            "</span><span class='popupSubtitle'>" +
            optionTitle +
            "</span>" +
            descriptionHtml +
            '<button item-id="' +
            customisations[i]["tab"]["options"][j]["option_value_id"] +
            '" class="button button--secondary apply_option">Apply</button></div>' +
            info_slider +
            "</div>";
          option_item_body_item +=
            '<li class="' +
            active +
            '" ' +
            value_depends_on +
            ' item-id="' +
            customisations[i]["tab"]["options"][j]["option_value_id"] +
            '" data-item="' +
            tabPropertyName +
            '" data-value="' +
            optionPropertyValue +
            '" data-display="' +
            optionTitle +
            '">' +
            oftenChosen +
            icon +
            optionTitle +
            iIcon +
            "</li>";
          popups += popup;
        }

        $(".product__media-wrapper").append(popups);

        let ifMonogram = "";
        if (customisations[i]["tab"]["title"] === "Monogram")
          ifMonogram = "monogramParent";
        var option_item_body =
          '<div class="' +
          ifMonogram +
          ' option_item_body"><ul>' +
          option_item_body_item +
          "</ul></div>";

        var option_item =
          '<div class="option_item" option-id="' +
          customisations[i]["tab"]["option_id"] +
          '" ' +
          option_depends_on +
          ">" +
          option_item_head +
          option_item_body +
          "</div>";

      }

      if (
        customisations[i]["tab"]["title"].includes("Monogram") &&
        customisations[i]["tab"]["title"] !== "Monogram"
      ) {

        $(".monogramParent").append(option_item);
      } else {

        $(".costomization_data .costomization_data--castomization").prepend(
          option_item
        );
        if (customisations[i]["tab"]["title"] === "Monogram") {
          let maxlength = 0;
          if (p_type === "Shirt") {
            maxlength = 5;
          } else {
            maxlength = 18;
          }
          /* Monogram text */
          var option_item_head =
            '<div class="option_item_head"><span class="option_title">Initials</span></div>';
          var option_item_body_item = "";
          html +=
            '<div class="item" data-option="monogram_text"><span class="option_title">Monogram text</span></div>';

          var option_item_body =
            '<div class="option_item_body"><input maxlength="' +
            maxlength +
            '" class="field__input" id="monogramText" type="text" name="monogram"></div>';

          var option_item =
            '<div class="option_item" depends-on-option-value="243" option-id="76">' +
            option_item_head +
            option_item_body +
            "</div>";

          $(".monogramParent").append(option_item);
        }
      }
    }

    $(".product-form__submit").prop("disabled", window.cartButtonState);
    $(".product-form__submit span").text(window.cartButtonText);

    /* Creating style details slider */

    $(".product-info--selected-options").slick("slickAdd", html);

    removeDependent();
    check_depends();
    addSelectedOptionsProperty();

    let desire = urlParams.get("editCustomizations");

    if (desire !== null) {
      $(".product_customization").click();
      /* edit customisations mode, looking for saved customisations */

      $.get("/cart.js", function (data) {
        var cart = $.parseJSON(data);

        $(".save_changes_button").show();
        $(".standard_cart_button").hide();

         let tuxedo = $(".product").attr("tuxedo");

  if (tuxedo !== "true" && tuxedo !== true) {
    tuxedo = 'No';
  } else {
    tuxedo = 'Yes';
  }
        
        $('#tuxedoProp').val(tuxedo).change();
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].properties._editCustomizations == desire) {
            let item_key = cart.items[i].key;
            for (const [key, value] of Object.entries(
              cart.items[i].properties
            )) {
            
              if (key === "_Monogram Text") {
                $("#monogramText").val(value).change();
              }
              $(
                '.option_item_body li[data-item="' +
                key.substring(1) +
                '"][data-value="' +
                value +
                '"]'
              ).click();
            }
          }
        }
      });
    }
  } else {
    $(".product_customization").hide();
  }
}

/* Open customisation tab */

$(document).on("click", ".option_item_head", function () {
 
  if ($(this).closest(".option_item").hasClass("active")) {
    $(this)
      .closest(".option_item")
      .removeClass("active")
      .find(".option_item_body")
      .slideUp();
  } else {
    let originalPos = $(".product__info-costomization").scrollTop();
    let topLevelHead = $(this);
    $(this)
      .closest(".option_item")
      .addClass("active")
      .find(".option_item_body")
      .slideDown({
        duration: 800,
        start: function () {
          $(".product__info-costomization").scrollTop(originalPos);
        },
        done: function () {
          topLevelHead.closest(".option_item").get(0).scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        },
      });
  }
});
/* update monogram text */

$(document).on("change", "#monogramText", function (e) {
  updateSelectedOptions({
    option_id: 76,
    option_name: "Monogram Text",
    value_name: e.target.value,
    value_id: 0,
    option_depends_on: [243],
    value_depends_on: [],
  });
  if ($('input[name="properties[_Monogram Text]"]').length > 0) {
    $('input[name="properties[_Monogram Text]"]').val(e.target.value).change();
  } else {
    $(".product-form-add").append(
      '<input type="hidden" name="properties[_Monogram Text]" value="' +
      e.target.value +
      '">'
    );
  }
});
/* select customisation option */

$(document).on("click", ".option_item_body li", function (e) {
  let originalPos = $(".product__info-costomization").scrollTop();
  if ($(this).hasClass("active")) {
    return false;
  }
  // ignore clicks on (i) icon
  if (
    $(e.target).is("svg") ||
    $(e.target).is("circle") ||
    $(e.target).is("line") ||
    $(e.target).is("span")
  ) {
    return false;
  }
  $(this).closest("ul").find("li").removeClass("active");
  $(this).addClass("active");

  let value = $(this).attr("data-value"),
    displayValue = $(this).attr("data-display") || $(this).attr("data-value"),
    item = $(this).attr("data-item"),
    value_depends_on = $(this).attr("depends-on-option-value"),
    option_id = $(this).closest(".option_item").attr("option-id"),
    option_depends_on = $(this)
      .closest(".option_item")
      .attr("depends-on-option-value"),
    image = $(this).find("img").attr("src"),
    item_id = $(this).attr("item-id");

  let text = $("#option_info_popup_" + item_id)
    .find(".information")
    .find("p")
    .text();

  updateSelectedOptions({
    option_id: +option_id,
    option_name: item,
    value_name: value,
    value_id: +item_id,
    option_depends_on:
      option_depends_on === undefined
        ? []
        : option_depends_on.split(",").map(Number),
    value_depends_on:
      value_depends_on === undefined
        ? []
        : value_depends_on.split(",").map(Number),
  });

  check_depends();

  if (window.location.hash != "#editCustomizations") {
    setCookie(item, item_id, 5, window.location.href);
  }

  /* update the selected option in customisation tab and style details */

  $(this)
    .closest(".option_item")
    .find(".option_item_head")
    .find("small")
    .html(displayValue);
  $(this)
    .closest(".option_item")
    .find(".option_item_head")
    .find("img")
    .attr("src", image)
    .attr("alt", displayValue);
  $('.product-info--selected-options .item[data-option="' + item + '"]')
    .find("small")
    .html(displayValue);
  $('input[name="properties[_' + item + ']"]')
    .val(value)
    .change();
  $('.product-info--selected-options .item[data-option="' + item + '"]')
    .find("img")
    .attr("src", image)
    .attr("alt", displayValue);
  $('.product-info--selected-options .item[data-option="' + item + '"]')
    .find("p")
    .text(text);

  check_depends();
  $(".product__info-costomization").scrollTop(originalPos);
});

/* update Selected options */

function updateSelectedOptions(option) {
  window.selectedCustomizations = window.selectedCustomizations.filter(
    (object) => {
      return object.option_id !== parseInt(option.option_id);
    }
  );
  window.selectedCustomizations.push(option);
}

/* view more options */

$(".costomization_data .show_more").on("click", function (e) {
  e.preventDefault();
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this).html(window.translations.viewMoreOptions || "View more options");
    $(".option_item").hide();
    $(
      ".option_item:nth-last-child(2), .option_item:nth-last-child(3), .option_item:nth-last-child(4)"
    ).show();
  } else {
    $(this).addClass("active");
    $(this).html(window.translations.viewLessOptions || "View less options");
    $(".option_item:not(.hide)").show();

    check_depends();
  }
});

/* open product customiser */

$(".product_customization").on("click", function (e) {
  e.preventDefault();
  if ($(window).width() > 750) {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    $(".product__info-container").hide();
    $(".customization_info").hide();
    $(".costomization_data").show();
  } else {
    $(".product__info-costomization").toggleClass("open");
    $(".customization_info").hide();
    $(".costomization_data").show();
  }
  check_depends();
});

/* close customiser */

$(".back_to_info").on("click", function (e) {
  e.preventDefault();
  if ($(window).width() > 750) {
    $(".customization_info, .costomization_data").hide();
    $(".product__info-container").show();
  } else {
    $(".product__info-costomization").toggleClass("open");
  }
});

/* view more in style details */

$(".product-info--accordion-item-content .view_more a").on(
  "click",
  function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).html("View more");
      $(".product-info--selected-options .item").hide();
      $(
        ".product-info--selected-options .item:nth-child(1),.product-info--selected-options .item:nth-child(2),.product-info--selected-options .item:nth-child(3),.product-info--selected-options .item:nth-child(4)"
      ).show();
    } else {
      $(this).addClass("active");
      $(this).html("View less");
      $(".product-info--selected-options .item").show();
    }
  }
);

function addSelectedOptionsProperty() {
  let selectedOptions = [];
  for (let sc of window.selectedCustomizations) {
    selectedOptions.push(sc.value_id);
  }
  selectedOptions = selectedOptions.join(",");
  $("#selectedOptionsProperty").val(selectedOptions);
  
  return selectedOptions;
}

function getEspixelAddToCartPayload() {
  const productId = $('input[name="id"]').val() || '';
  const quantity = parseInt($('input[name="quantity"]').val() || '1', 10) || 1;
  const productTitle = ($('.product__title').text() || $('h1.product__title').text() || document.title || '').trim();
  const priceText = ($('.price__container .price-item--sale, .price__container .price-item--regular, .price__regular .price-item--regular').first().text() || '').trim();

  return {
    productId: productId,
    product: productTitle,
    price: priceText,
    quantity: quantity
  };
}

/* overriding default add to cart button */

$(".product-form__submit").on("click", function () {
  if (window.trackEspixel) {
    window.trackEspixel('addToCart', getEspixelAddToCartPayload());
  }

  if (window.customisable) {
  
    let random_id =
      Math.floor(Math.random() * (99999999 - 10000001)) + 10000001;
    $('input[name="properties[_editCustomizations]"]').val(random_id).change();
  }
});

// product customization add to cart button
$(".bottom_line .add_to_cart").on("click", function (e) {
  e.preventDefault();
  var desire = urlParams.get("editCustomizations");
  if (desire != null) {
    /* editing saved customisation */
    let item_key = 0;
    $.get("/cart.js", function (data) {
      var cart = $.parseJSON(data);
      var properties = {
        _editCustomizations: desire,
      };
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].properties._editCustomizations == desire) {
          item_key = i + 1;
          properties["Status"] = cart.items[i].properties['Status'];
        }
      }

      properties["_selectedOptions"] = addSelectedOptionsProperty();
      properties["_Fabric Code"] = $("#fabricCode").val();
      properties["_Tuxedo"] = $('#tuxedoProp').val();
      properties["_productCategory"] = $("#productCategory").val();

      $(".option_item_body")
        .each(function (index, element) {
          let item = $(element).find("li.active").attr("data-item"),
            value = $(element).find("li.active").attr("data-value");
          properties["_" + item] = value;
        })
        .promise()
        .done(function () {
          if ($('#monogramText').val().length) {
            properties["_Monogram Text"] = $('#monogramText').val();
          }
          $.post("/cart/change.js", {
            line: item_key,
            properties: properties,
          })
            .done(function () {
              window.location = "/cart";
            })
            .fail(function (error) {
           
            });
        });
    });
  } else {
    /* adding new product to cart with customisations */

    addSelectedOptionsProperty();
    $(".product-form__submit").click();
  }
});

/* Initialize style details and info popup sliders */

if ($(".product-info--selected-options").length > 0) {
  let rows = 1;
  let slidesPerRow = 10;
  if ($(window).width() < 750) {
    rows = 10;
    slidesPerRow = 1;
  }

  $(".product-info--selected-options").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    rows,
    slidesPerRow,
    slidesToScroll: 1,
    variableWidth: true,
    prevArrow:
      '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--15600283320497__16545148190446716e"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--15600283320497__16545148190446716e"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
  });

  $(".product-info--selected-options").slick("slickFilter", ".show");
  $(".info_slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    prevArrow:
      '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--15600283320497__16545148190446716e"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--15600283320497__16545148190446716e"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
  });
}

/* popup focus and interactions switch */

function disableInteraction() {

  $(".ESoverlay").show();
  $(".product__info-costomization").css("overflow", "hidden");
  //$('body').css('overflow', 'hidden').css('width', '100vw').css('height', '100vh').css('overflow-y', 'scroll').css('overflow-x','hidden').css('-webkit-overflow-scrolling', 'touch');
  $("html")
    .css("position", "fixed")
    .css("height", "100%")
    .css("overflow", "hidden");
  $(".product__media-wrapper").css("overflow", "hidden");
  //$('.product__info-costomization').css('pointer-events', 'none');
  $("media-gallery").css("pointer-events", "none");
  $("header").css("pointer-events", "none");
}
function enableInteraction() {
 
  $(".ESoverlay").hide();
  $(".product__info-costomization").css("overflow", "auto");
  $("body").css("overflow", "auto");
  $("html")
    .css("position", "unset")
    .css("height", "auto")
    .css("overflow", "auto");
  $(".product__media-wrapper").css("overflow", "auto");
  //$('.product__info-costomization').css('pointer-events', 'auto');
  $("media-gallery").css("pointer-events", "auto");
  $("header").css("pointer-events", "auto");
}

/* open info popup */

$(document).on("click", ".option_item_body ul li span", function () {
  $(".option_info_popup").removeClass("active");

  let itemId = $(this).parent("li").attr("item-id");

  if (
    !$("#option_info_popup_" + itemId + " .info_slider").hasClass(
      "slick-initialized"
    )
  ) {
    $("#option_info_popup_" + itemId + " .info_slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      prevArrow:
        '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--15600283320497__16545148190446716e"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
      nextArrow:
        '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--15600283320497__16545148190446716e"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
    });
  }
  disableInteraction($("#option_info_popup_" + itemId));
  $("#option_info_popup_" + itemId).addClass("active");
  $("#option_info_popup_" + itemId)
    .find(".info_slider")
    .slick("setPosition");
  $(".gallery_switcher").addClass("non_visible");
});

/* close info popup */

$(document).on("click", ".option_info_popup a, .ESoverlay", function () {
  $(".option_info_popup").removeClass("active");
  $(".gallery_switcher").removeClass("non_visible");

  enableInteraction();
});

$(document).on("click", ".apply_option", function (event) {
  $(".option_info_popup").removeClass("active");
  $(".gallery_switcher").removeClass("non_visible");
  enableInteraction();
  $('li[item-id="' + $(event.target).attr("item-id") + '"]').click();
});

$(document).on("click", ".option_info_popup button", function () {
  $(this).parent(".option_info_popup").removeClass("active");
  $(".gallery_switcher").removeClass("non_visible");
});

/* open customisation from style details */

$("#customizeLink").on("click", function (event) {
  event.preventDefault();
  document.body.scrollTop = document.documentElement.scrollTop = 0;
  $(".product_customization").click();
});

/* estimated delivery date */

$.get(
  "https://api.v3.editsuits.com/store/estimateddelivery/" + $("#fabricCode").val()
).then((data) => {
  if(!$('.delivery').hasClass('readyToWearDelivery')) {
  $(".delivery span").text(data);
  }
  if (data !== 'error') {
    if ($(window).width()  > 750) {
      $(".delivery_guaranty").show();
    }
  }
});

/* option description toggle in Style Details */

$(function () {
  $(document).on(
    "click",
    ".item-mobile, .optionDescription, .item-mobile, .optionDescription span, .item-mobile, .optionDescription svg",
    function () {
      event.preventDefault;

      $(this).closest("div").toggleClass("active");
    }
  );
});
